namespace Device {
    export enum types {
        Desktop = 'desktop',
        Tablet = 'tablet',
        Mobile = 'mobile',
        MobileSmall = 'mobile-small',
        MobileLandscape = 'mobile-landscape',
    }
    
    export const breakpoints: {[k in types]?: {min?: number, max?: number}} = {
        [types.Desktop]:  {min: 1280},
        [types.Tablet]:  {min: 768, max: 1279},
        [types.Mobile]:  {min: 320, max: 767},
        [types.MobileSmall]:  {max: 480},
    };
}

export default Device;